import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.map.js';
import React from 'react';
import { isFunction } from 'lodash';
import { CheckOutline } from 'antd-mobile-icons';
import classNames from 'classnames';
import TiSpin from '../../TiSpin/index.js';
import { TiException } from '../../TiException/index.js';
import getItemNodeAndConfig from '../../utils/getItemNodeAndConfig.js';
import getRowKey from '../../utils/getRowKey.js';
import useLanguage from '../../hooks/useLangugle/index.js';
import './index.less.js';

var Body = function Body(props) {
  var _a = props.data,
    data = _a === void 0 ? [] : _a,
    renderItem = props.renderItem,
    status = props.status,
    rowKey = props.rowKey,
    empty = props.empty,
    onReset = props.onReset,
    presetItemStyle = props.presetItemStyle,
    onItemClick = props.onItemClick;
  var ListLocale = useLanguage('List');
  if (!isFunction(renderItem)) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  if (status === 'error') {
    return /*#__PURE__*/React.createElement("div", {
      className: "ti-list-init"
    }, /*#__PURE__*/React.createElement(TiException.Network, {
      title: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "ti-list-error-text"
      }, "".concat(ListLocale.networkError, ",")), /*#__PURE__*/React.createElement("span", {
        className: "ti-list-error-trigger",
        onClick: onReset
      }, ListLocale.clickRetry))
    }));
  }
  if (status === 'init-loading') {
    return /*#__PURE__*/React.createElement("div", {
      className: "ti-list-init"
    }, /*#__PURE__*/React.createElement(TiSpin, {
      size: "middle",
      presetStyle: "spin"
    }));
  }
  if (empty) {
    return /*#__PURE__*/React.createElement("div", {
      className: "ti-list-init"
    }, /*#__PURE__*/React.createElement(TiException.Empty, null));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "ti-list-body"
  }, data.map(function (x, i) {
    var key = getRowKey(x, rowKey);
    var result = renderItem(x, i);
    var _a = getItemNodeAndConfig(result),
      node = _a.node,
      config = _a.config;
    var disabled = config.disabled,
      active = config.active;
    var splitLineStyleActive = presetItemStyle === 'split-line' && active;
    var cardStyleActive = presetItemStyle === 'card' && active;
    var itemCls = classNames({
      'ti-list-item': true,
      'ti-list-item-style-card': presetItemStyle === 'card',
      'ti-list-item-style-card-active': cardStyleActive,
      'ti-list-item-style-split-line': presetItemStyle === 'split-line',
      'ti-list-item-style-split-line-active': splitLineStyleActive,
      'ti-list-item-disabled': disabled
    });
    var contentCls = classNames({
      'ti-list-item-content': true,
      'ti-list-item-content-disabled': disabled
    });
    var handleItemClick = function handleItemClick(x) {
      if (disabled) {
        return;
      }
      if (isFunction(onItemClick)) {
        onItemClick(x, active);
      }
    };
    return /*#__PURE__*/React.createElement("div", {
      key: key,
      className: itemCls
    }, /*#__PURE__*/React.createElement("div", {
      className: contentCls,
      onClick: function onClick() {
        return handleItemClick(x);
      }
    }, node), splitLineStyleActive ? /*#__PURE__*/React.createElement("div", {
      className: "ti-list-item-content-split-line-active"
    }, /*#__PURE__*/React.createElement(CheckOutline, {
      color: "var(--adm-color-primary)"
    })) : null);
  }));
};

export { Body as default };
